import { useEffect, useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { getRedemptionStorage } from '@jsmdg/browser-storage';
import {
    ArrowIcon,
    Link,
    LinkVariant,
    Notification,
    NotificationVariant,
    RenderType,
} from '@jsmdg/yoshi';
import styles from './RedemptionInfoBanner.module.scss';

const messages = defineMessages({
    buyingVoucherDisbaledMessage: {
        defaultMessage:
            'Der Wert deines Erlebnisgutscheins kann nicht auf einen neuen Gutschein angerechnet werden.',
    },
    linkMessage: {
        defaultMessage: 'Einlöse abbrechen und Gutschein kaufen',
    },
});

const RedemptionInfoBanner = (): JSX.Element => {
    const intl = useIntl();
    const redemptionStorage = getRedemptionStorage();

    const linkRef = useRef<HTMLAnchorElement | HTMLButtonElement>(null);

    useEffect(() => {
        const removeRedemptionStorage = () => {
            redemptionStorage.clear();
            window.location.reload();
        };

        // The Accordion item is disabled,
        // to handle click on link inside a disabled accordion item,
        // we need to use EventListener otherwise the onclick event will be ignored.
        const link = linkRef.current;
        link?.addEventListener('click', removeRedemptionStorage);

        return () => {
            link?.removeEventListener('click', removeRedemptionStorage);
        };
    }, [redemptionStorage]);

    return (
        <div>
            <div className="pt-2x d-flex w-100">
                <Notification
                    variant={NotificationVariant.Warning}
                    message={intl.formatMessage(messages.buyingVoucherDisbaledMessage)}
                />
            </div>
            <Link
                ref={linkRef}
                variant={LinkVariant.Brand}
                as={RenderType.Button}
                iconRight={<ArrowIcon className={styles.arrowIcon} />}
            >
                {intl.formatMessage(messages.linkMessage)}
            </Link>
        </div>
    );
};

export { RedemptionInfoBanner };
